import {
  utilityActionTypes,
  SHOW_NOTIFICATION,
  NotificationData,
} from './types';

const utilityActions = {
  showNotification: (payload: NotificationData): utilityActionTypes => ({
    type: SHOW_NOTIFICATION,
    payload,
  }),
};

export default utilityActions;
